import { service } from '@/utils/request'

export function login(params) {
    return service({
        url: 'bt_rich/login_trader_admin',
        method: 'get',
        params
    })
}

// ---------- 交易配置 ----------
export function getTradeConfig(params) {
    return service({
        url: 'bt_rich/get_trade_config',
        method: 'get',
        params
    })
}

export function setTradeConfig(params) {
    return service({
        url: 'bt_rich/set_trade_config_bull_bear_manual',
        method: 'get',
        params
    })
}

// ---------- 机器人管理 ----------
// 更新机器人
export function updateRobotParamTask(params) {
    return service({
        url: 'bt_rich/update_robot_param_task',
        method: 'get',
        params
    })
}
// 添加机器人
export function addRobotParamTask(params) {
    return service({
        url: 'bt_rich/add_robot_param_task',
        method: 'get',
        params
    })
}
// 获取机器人列表
export function getRobotParamList(params) {
    return service({
        url: 'bt_rich/list_robot_param_tasks',
        method: 'get',
        params
    })
}

// ---------- 带单管理 ----------
// 下单 /R/create_lead_task
export function createLeadTask(params) {
    return service({
        url: 'R/create_lead_task',
        method: 'get',
        params
    })
}
// 查询仓位 /R/get_position_summary
export function getPositionSummary(params) {
    return service({
        url: 'R/get_position_summary',
        method: 'get',
        params
    })
}
// 清仓 R/clear_position
export function clearPosition(params) {
    return service({
        url: 'R/clear_position',
        method: 'get',
        params
    })
}
// 历史操作记录  R/get_lead_task_list
export function getLeadTaskList(params) {
    return service({
        url: 'R/get_lead_task_list',
        method: 'get',
        params
    })
}